import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Login} from './components/Login'
import {LoginK12} from './components/LoginK12'
import {EducationLogo} from '../../../components/EducationLogo'
import {UiIcon} from '../../../components/UiIcon'
import './AuthPage.scss'

const AuthLayout = () => {
  useEffect(() => {
    const background = document.body.style.backgroundImage
    document.body.style.backgroundImage = 'none'
    return () => {document.body.style.backgroundImage = background}
  }, [])

  return <main className='education-auth'>
    <aside className='auth-story' aria-labelledby='auth-story-title'>
      <img className='auth-story-image' src='https://files.gokidly.com/web/assets/general/app-store-bg.jpg' alt='' referrerPolicy='no-referrer'/>
      <div className='auth-story-top'><span className='auth-story-emblem'><UiIcon name='book' size={23}/></span><span>Sınıfta ihtiyacınız olacak her şey tek bir yerde</span></div>
      <div className='auth-story-copy'>
        <span className='auth-story-eyebrow'>Kitaplar, Etkinlikler ve Daha Fazlası</span>
        <h2 id='auth-story-title'>Öğrencileriniz için <span>zengin bir okuma deneyimi.</span></h2>
        <p>Yüzlerce kitap, eğlenceli etkinlikler ve öğrenci gelişimini takip etmenizi sağlayan araçlar bir arada.</p>
        <div className='auth-story-features'><span><UiIcon name='book' size={16}/>Hikâyeler</span><span><UiIcon name='activity' size={16}/>Etkinlikler</span><span><UiIcon name='people' size={16}/>Öğrenci takibi</span></div>
      </div>
    </aside>
    <section className='auth-workspace' aria-label='Öğretmen hesabınıza giriş'>
      <div className='auth-workspace-top'>
        <div className='auth-brand-pair'>
          <EducationLogo placement='auth'/>
          <span className='auth-brand-divider' aria-hidden='true'/>
          <span className='auth-partner-mark'>
            <img src={`${(process.env.PUBLIC_URL || '').replace(/\/$/, '')}/media/logos/okudemi-wordmark.png`} alt='Okudemi' width='1185' height='459' decoding='sync'/>
          </span>
        </div>
        <span className='auth-panel-label'>Öğretmen paneli</span>
      </div>
      <div className='auth-form-content'><Outlet/></div>
      <footer className='auth-footer'>
        <span>© {new Date().getFullYear()} Kidly</span>
        <nav aria-label='Giriş ekranı bağlantıları'><a href='https://gokidly.com/' target='_blank' rel='noopener noreferrer'>Hakkımızda</a><a href='https://gokidly.com/#contact' target='_blank' rel='noopener noreferrer'>İletişim<UiIcon name='external' size={13}/></a></nav>
      </footer>
    </section>
  </main>
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout/>}>
      <Route path='login' element={<Login/>}/>
      <Route path='k12' element={<LoginK12/>}/>
      <Route index element={<Login/>}/>
    </Route>
  </Routes>
)

export {AuthPage}
